/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { DocumentImageList } from '../models/DocumentImageList';
import type { UpdateDocumentImageDisplayOption } from '../models/UpdateDocumentImageDisplayOption';

import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';

export class DocumentImagesService {

    /**
     * Upload document images (multiple files supported)
     * @param formData
     * @returns any Created
     * @throws ApiError
     */
    public static documentImagesUploadDocumentImages(
        formData?: {
            files?: Array<Blob>;
            displayOption?: number;
        },
    ): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/documentImages/upload',
            formData: formData,
            mediaType: 'multipart/form-data',
            errors: {
                400: `Bad Request`,
                500: `Server Error`,
            },
        });
    }

    /**
     * Get all document images for a show
     * @param showId
     * @returns DocumentImageList Success
     * @throws ApiError
     */
    public static documentImagesGetDocumentImages(
        showId: string,
    ): CancelablePromise<Array<DocumentImageList>> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/documentImages/{showId}',
            path: {
                'showId': showId,
            },
            errors: {
                400: `Bad Request`,
                500: `Server Error`,
            },
        });
    }

    /**
     * Get all common document images (not tied to specific show)
     * @returns DocumentImageList Success
     * @throws ApiError
     */
    public static documentImagesGetCommonDocumentImages(): CancelablePromise<Array<DocumentImageList>> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/documentImages/common',
            errors: {
                400: `Bad Request`,
                500: `Server Error`,
            },
        });
    }

    /**
     * Delete a document image
     * @param imageId
     * @returns any Success
     * @throws ApiError
     */
    public static documentImagesDeleteDocumentImage(
        imageId: string,
    ): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'DELETE',
            url: '/api/documentImages/{imageId}',
            path: {
                'imageId': imageId,
            },
            errors: {
                400: `Bad Request`,
                404: `Not Found`,
                500: `Server Error`,
            },
        });
    }

    /**
     * Update display option for a document image
     * @param imageId
     * @param requestBody
     * @returns any Success
     * @throws ApiError
     */
    public static documentImagesUpdateDisplayOption(
        imageId: string,
        requestBody?: UpdateDocumentImageDisplayOption,
    ): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'PUT',
            url: '/api/documentImages/{imageId}/display-option',
            path: {
                'imageId': imageId,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Bad Request`,
                404: `Not Found`,
                500: `Server Error`,
            },
        });
    }

}
